import { defineComponent as _defineComponent } from 'vue'

const __default__ = {}

import { __ } from '@@/bits/intl'
import OzContainedButton, { OzContainedButtonColorScheme } from '@@/library/v4/components/OzContainedButton.vue'
import OzDrawerStatic from '@@/library/v4/components/OzDrawerStatic.vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzDrawerConfirmationDialog',
  props: {
    title: null,
    iconSrc: { default: null },
    iconAlt: { default: null },
    body: { default: undefined },
    confirmButtonText: { default: undefined },
    cancelButtonText: { default: undefined },
    shouldFadeIn: { type: Boolean, default: true }
  },
  emits: ['confirm', 'cancel'],
  setup(__props: any) {

const props = __props as { title: string, iconSrc: string | null, iconAlt: string | null, body: string, confirmButtonText: string, cancelButtonText: string, shouldFadeIn: boolean }



const buttons = computed(() => {
  return [
    {
      text: props.confirmButtonText || __('Continue'),
      emit: 'confirm',
      colorScheme: OzContainedButtonColorScheme.Primary,
      testId: 'confirmButton',
    },
    {
      text: props.cancelButtonText || __('Cancel'),
      emit: 'cancel',
      colorScheme: OzContainedButtonColorScheme.Secondary,
      testId: 'cancelButton',
    },
  ]
})



return { __sfc: true,props, buttons, OzContainedButton, OzDrawerStatic }
}

})